<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" side="start">

      <ion-header [translucent]="true">
        <ion-toolbar>        
          <div slot="start" class="menu-logo-wrapper">
            <ion-img class="menu-logo" src="assets/icon/favicon.png"></ion-img>
          </div>
          <ion-title>  
            Yoggl
          </ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content>
        <div class="main-menu">
          <div>

            <ion-list *ngIf="showAdminMenu">
              <div *ngFor="let p of adminPages; let i = index">
                <ion-menu-toggle auto-hide="false">
                  <ion-item 
                    routerDirection="root" 
                    [routerLink]="[p.url]" 
                    lines="none" 
                    detail="false" 
                    routerLinkActive="selected"
                    class="main-menu-item">
                    <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
                    <ion-label>{{ p.title }}</ion-label>
                  </ion-item>
                </ion-menu-toggle>
                
                <div *ngIf="p.subOptions && p.subOptions.length > 0 && shouldShowSubOptions(p.url)" class="submenu-container">
                  <ion-menu-toggle auto-hide="false" *ngFor="let subOption of p.subOptions">
                    <ion-item 
                      *ngIf="!subOption.isCurrentPage"
                      routerDirection="root" 
                      [routerLink]="[subOption.url]" 
                      lines="none" 
                      detail="false" 
                      routerLinkActive="selected"
                      class="submenu-item">
                      <ion-icon slot="start" [name]="subOption.icon" size="small"></ion-icon>
                      <ion-label>{{ subOption.title }}</ion-label>
                    </ion-item>
                    <ion-item 
                      *ngIf="subOption.isCurrentPage"
                      lines="none" 
                      detail="false" 
                      class="submenu-item submenu-current-indicator">
                      <ion-icon slot="start" [name]="subOption.icon" size="small"></ion-icon>
                      <ion-label>{{ subOption.title }}</ion-label>
                    </ion-item>
                  </ion-menu-toggle>
                </div>
              </div>
            </ion-list>

            <ion-list *ngIf="!showAdminMenu">
              <div *ngFor="let p of creatorPages; let i = index">
                <ion-menu-toggle auto-hide="false">
                  <ion-item
                    routerDirection="root"
                    [routerLink]="[p.url]"
                    lines="none"
                    detail="false"
                    routerLinkActive="selected"
                    class="main-menu-item"
                    [title]="p.url === '/admin/facilities/my-facility' && pendingOnboardingCount > 0
                      ? 'Für ' + pendingOnboardingCount + ' Einrichtung' + (pendingOnboardingCount > 1 ? 'en' : '') + ' fehlen noch die neuen Angaben – hier ergänzen'
                      : null">
                    <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
                    <ion-label>{{ p.title }}</ion-label>
                    <ion-badge
                      *ngIf="p.url === '/admin/facilities/my-facility' && pendingOnboardingCount > 0"
                      slot="end"
                      color="primary"
                      class="onboarding-badge">
                      {{ pendingOnboardingCount }}
                    </ion-badge>
                  </ion-item>
                </ion-menu-toggle>
                
                <div *ngIf="p.subOptions && p.subOptions.length > 0 && shouldShowSubOptions(p.url)" class="submenu-container">
                  <ion-menu-toggle auto-hide="false" *ngFor="let subOption of p.subOptions">
                    <ion-item 
                      *ngIf="!subOption.isCurrentPage"
                      routerDirection="root" 
                      [routerLink]="[subOption.url]" 
                      lines="none" 
                      detail="false" 
                      routerLinkActive="selected"
                      class="submenu-item">
                      <ion-icon slot="start" [name]="subOption.icon" size="small"></ion-icon>
                      <ion-label>{{ subOption.title }}</ion-label>
                    </ion-item>
                    <ion-item 
                      *ngIf="subOption.isCurrentPage"
                      lines="none" 
                      detail="false" 
                      class="submenu-item submenu-current-indicator">
                      <ion-icon slot="start" [name]="subOption.icon" size="small"></ion-icon>
                      <ion-label>{{ subOption.title }}</ion-label>
                    </ion-item>
                  </ion-menu-toggle>
                </div>
              </div>
            </ion-list>
          </div>

          <ion-list>
            <ion-list>
              <ion-list-header>
                Profileinstellungen
              </ion-list-header>
              <ion-item routerLink="/admin/change-password" lines="none">
                <ion-icon slot="start" name="key-outline"></ion-icon>
                <ion-label>Passwort ändern</ion-label>
              </ion-item>
              <ion-item *ngIf="user?.isAdmin && (user?.username === 'SyscoreAdmin' || user?.username === 'admin')" lines="none" routerLink="/" (click)="compressImages()">
                <ion-icon slot="start" name="images-outline"></ion-icon>
                <ion-label>Bilder komprimieren</ion-label>
              </ion-item>
              <ion-item *ngIf="user?.isAdmin && (user?.username === 'SyscoreAdmin' || user?.username === 'admin')" lines="none" routerLink="/" (click)="preprocessFacilityDescriptions()">
                <ion-icon slot="start" name="link-outline"></ion-icon>
                <ion-label>Einrichtungslinks umwandeln</ion-label>
              </ion-item>
              <ion-item *ngIf="user?.isAdmin && (user?.username === 'SyscoreAdmin' || user?.username === 'admin')" lines="none" routerLink="/" (click)="backfillFacilityLocations()">
                <ion-icon slot="start" name="location-outline"></ion-icon>
                <ion-label>Standorte nachtragen</ion-label>
              </ion-item>
              <ion-item *ngIf="user?.isAdmin && (user?.username === 'SyscoreAdmin' || user?.username === 'admin')" lines="none" routerLink="/" (click)="fixGatheringEndDates()">
                <ion-icon slot="start" name="calendar-outline"></ion-icon>
                <ion-label>Veranstaltungs-Enddaten reparieren</ion-label>
              </ion-item>
              <ion-item *ngIf="user?.isAdmin && (user?.username === 'SyscoreAdmin' || user?.username === 'admin')" lines="none" routerLink="/" (click)="sendTestBroadcast()">
                <ion-icon slot="start" name="notifications-outline"></ion-icon>
                <ion-label>Test-Broadcast senden</ion-label>
              </ion-item>
            </ion-list>
            <ion-item lines="none">
              <ion-text>
                {{ user ? 'Eingeloggt als ' + user.username + '.' : '-' }}
              </ion-text>
              <ion-button (click)="logout()" slot="end">
                <ion-icon color="white" name="log-out-outline"></ion-icon>
              </ion-button>
            </ion-item>
          </ion-list>

        </div>

      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content">
    </ion-router-outlet>
  </ion-split-pane>
</ion-app>
